import { useStates } from 'lib/hooks/queries/states/useStates';
import { formatPhoneNumber, getFullAddress, ia } from 'lib/helpers/utility';

import Typography from 'components/shared/Typography/Typography';

// Renders the real practice identity on the Dr. ClearCare Good Faith Estimate.
// The `practice` is sourced from the checkin appointment payload (the only
// source populated on this Secure Payment path — `currentPractice` is empty
// here) so the GFE never ships placeholder identity on a federally-required
// document. Every line renders only when present.
const PracticeLetterhead = ({ practice }) => {
  const { data: statesData } = useStates();

  // `practiceAddress.state` is a numeric FK to states.id, so resolve it through
  // the shared getFullAddress helper (handles the id → abbreviation lookup)
  // rather than printing the raw id. A flat `address` string is used as-is.
  const addressLine =
    practice?.address ||
    getFullAddress({ address: practice?.practiceAddress, states: statesData?.states });

  const contactLine = [
    practice?.phone ? `Phone: ${formatPhoneNumber(practice.phone)}` : null,
    practice?.npi ? `NPI: ${practice.npi}` : null,
    practice?.tax_id ? `TIN: ${practice.tax_id}` : null
  ]
    .filter(Boolean)
    .join(' · ');

  const details = [addressLine, contactLine].filter(Boolean);

  if (!practice?.name && !ia(details)) return null;

  return (
    <div className="border-0 border-b border-solid border-neutral-200 bg-white">
      <div className="mx-auto w-full max-w-[768px] px-4 py-4">
        {practice?.name && (
          <Typography variant="p" size="medium" weight="semibold" className="text-primary-900">
            {practice.name}
          </Typography>
        )}
        {details.map((line, idx) => (
          <Typography key={idx} variant="p" size="xs" className="leading-5 text-neutral-700">
            {line}
          </Typography>
        ))}
      </div>
    </div>
  );
};

export default PracticeLetterhead;
